module.exports = __webpack_public_path__ + "img/girl_bg.700a71d7.jpg";